import { render } from "./ProvinceCitySelectorPC.vue?vue&type=template&id=a96f5676&scoped=true"
import script from "./ProvinceCitySelectorPC.vue?vue&type=script&lang=js"
export * from "./ProvinceCitySelectorPC.vue?vue&type=script&lang=js"

import "./ProvinceCitySelectorPC.vue?vue&type=style&index=0&id=a96f5676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96f5676"]])

export default __exports__